import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  width: 100%;

  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

export const ChartWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    .apexcharts-tooltip.apexcharts-theme-light {
      border: none;
      box-shadow: none;
      background: transparent;
    }

    .tooltip-chart {
      background: ${theme.colors.globalWhite100};
      border: 1px solid ${theme.colors.neutralSilver10};
      border-radius: 8px;
      padding: 12px;

      width: 178px;

      .tooltip-chart-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      dt {
        margin-bottom: 4px;
      }

      dd {
        margin: 0;
      }

      p {
        font-weight: 400;
        font-size: 1.2rem;
        line-height: 1.9rem;
        color: ${theme.colors.neutralSilver90};
      }

      span {
        font-size: 1.2rem;
        line-height: 1.9rem;

        &.sc {
          color: ${theme.colors.primary60};
          font-weight: 500;
        }

        &.tf {
          color: ${theme.colors.statusDanger30};
          font-weight: 400;
        }
      }

      strong {
        font-weight: 500;
        font-size: 1.2rem;
        line-height: 1.9rem;
        color: ${theme.colors.neutralSilver90};
      }
    }
  `}
`;

export const MobileOnly = styled.div`
  @media (min-width: 993px) {
    display: none;
  }
`;

export const DesktopOnly = styled.div`
  @media (max-width: 992px) {
    display: none;
  }
`;

export const LegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  @media (max-width: 992px) {
    flex-direction: row;
  }
`;

export const TotalSavingsContainer = styled.div`
  text-align: center;
`;

export const TotalSavings = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.statusSuccess30};
    font-size: 1.6rem;
    line-height: 2.6rem;
    font-weight: 600;
  `}
`;
